import React from 'react'

import { Container } from './styles'

const ModalContent = () => <Container>Senha alterada com sucesso!</Container>

export default ModalContent
